import styled from '@emotion/styled';
import { themed, ITheme } from '../../themer';
import { Responsive } from '../../utils';

export interface IIframeWrapProps {
	maxWidth?: number;
	maxHeight?: number;
	isVideo?: boolean;
}

export const IframeWrap = styled.div<IIframeWrapProps, ITheme>`
	position: relative;
	width: 100%;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		max-width: 100%;
	}

	iframe {
		background: ${themed(({ background }) => background.light)};
		aspect-ratio: ${({ maxWidth, maxHeight }) =>
			maxWidth && maxHeight ? `${maxWidth} / ${maxHeight}` : '16 / 9'};

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			aspect-ratio: ${({ isVideo }) => (isVideo ? '16 / 9' : '3 / 4')};
		}
	}
`;
